import React, { useState } from 'react';
import api from '../../services/api';

const FloorList = ({ projectId, floors, onUpdate }) => {
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({ name: '', sort_order: 0 });
  const [editingFloor, setEditingFloor] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingFloor) {
        await api.put(`/floors/${editingFloor.id}`, formData);
      } else {
        await api.post(`/project/${projectId}/floors`, formData);
      }
      setShowForm(false);
      setEditingFloor(null);
      setFormData({ name: '', sort_order: 0 });
      onUpdate();
    } catch (error) {
      console.error('Error saving floor:', error);
      alert('Failed to save floor');
    }
  };

  const handleEdit = (floor) => {
    setEditingFloor(floor);
    setFormData({ name: floor.name, sort_order: floor.sort_order });
    setShowForm(true);
  };

  const handleDelete = async (floorId) => {
    if (window.confirm('Delete this floor? All associated budgets and logs will be deleted.')) {
      try {
        await api.delete(`/floors/${floorId}`);
        onUpdate();
      } catch (error) {
        console.error('Error deleting floor:', error);
        alert('Failed to delete floor');
      }
    }
  };

  const handleCancel = () => {
    setShowForm(false);
    setEditingFloor(null);
    setFormData({ name: '', sort_order: 0 });
  };

  return (
    <div className="floor-list">
      <div style={{ marginBottom: '20px', marginLeft: '2rem' }}>
        <button onClick={() => setShowForm(true)} className="primary">
          + Add Floor
        </button>
      </div>

      {showForm && (
        <div className="card" style={{ marginBottom: '20px' }}>
          <h3>{editingFloor ? 'Edit Floor' : 'New Floor'}</h3>
          <form onSubmit={handleSubmit}>
            <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '15px' }}>
              <div className="form-group">
                <label>Floor Name *</label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  placeholder="e.g., B2, Ground, 2, 3, Roof"
                  required
                />
              </div>
              <div className="form-group">
                <label>Sort Order</label>
                <input
                  type="number"
                  value={formData.sort_order}
                  onChange={(e) => setFormData({ ...formData, sort_order: parseInt(e.target.value) })}
                />
              </div>
            </div>
            <div style={{ display: 'flex', gap: '10px', marginTop: '15px' }}>
              <button type="submit" className="primary">Save</button>
              <button type="button" onClick={handleCancel} className="secondary">Cancel</button>
            </div>
          </form>
        </div>
      )}

      <div className="card">
        <h3>Floors ({floors.length})</h3>
        {floors.length > 0 ? (
          <table>
            <thead>
              <tr>
                <th>Floor Name</th>
                <th>Sort Order</th>
                <th>Budgets</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {floors.map(floor => (
                <tr key={floor.id}>
                  <td><strong>{floor.name}</strong></td>
                  <td>{floor.sort_order}</td>
                  <td>{floor.budgets?.length || 0} elements</td>
                  <td>
                    <button 
                      onClick={() => handleEdit(floor)} 
                      className="secondary"
                      style={{ marginRight: '10px', padding: '6px 12px', fontSize: '12px' }}
                    >
                      Edit
                    </button>
                    <button 
                      onClick={() => handleDelete(floor.id)} 
                      className="danger"
                      style={{ padding: '6px 12px', fontSize: '12px' }}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No floors added yet. Click "Add Floor" to get started.</p>
        )}
      </div>
    </div>
  );
};

export default FloorList;